module.exports = __webpack_public_path__ + "static/media/platform-default-icon.a86c92d97bb2b7003f78ada886d44755.png";